import { Container, Card, Row, Col, Button } from 'react-bootstrap';
import { FaKey, FaLink, FaRobot, FaCode, FaCheckCircle, FaTools } from 'react-icons/fa';
import ScrollAnimationWrapper from '../Other/ScrollAnimationWrapper';
import { Link } from 'react-router-dom';

const APIDocumentation = () => {
    return (
        <div style={{ minHeight: '100vh', color: '#fff' }}>
            <Container className="p-4">
                <Row className="justify-content-center">
                    <Col lg={10}>
                        {/* Header */}
                        <div className="text-center mb-5">
                            <FaRobot size={48} style={{ color: '#17a2b8', marginBottom: '16px' }} />
                            <h1 style={{ color: '#fff', marginBottom: '12px' }}>Quickychat API Documentation</h1>
                            <p style={{ color: '#ccc', fontSize: '18px' }}>
                                Learn how to connect and interact with your Quickychat AI Agent using the API
                            </p>
                        </div>

                        {/* Step 1 */}
                        <Card style={{ backgroundColor: '#2d2d2d', borderColor: '#444', marginBottom: '24px' }}>
                            <Card.Header style={{ backgroundColor: '#333', borderBottom: '1px solid #444', padding: '20px' }}>
                                <div className="d-flex align-items-center">
                                    <div
                                        style={{
                                            backgroundColor: '#1a3a52',
                                            borderRadius: '50%',
                                            width: '40px',
                                            height: '40px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginRight: '16px'
                                        }}
                                    >
                                        <span style={{ color: '#fff', fontWeight: 'bold' }}>1</span>
                                    </div>
                                    <div>
                                        <h5 style={{ color: '#fff', margin: 0 }}>Create an Account</h5>
                                        <small style={{ color: '#ccc' }}>Sign up to access Quickychat services</small>
                                    </div>
                                </div>
                            </Card.Header>
                            <Card.Body style={{ padding: '24px' }}>
                                <ol style={{ color: '#ccc', lineHeight: '1.6' }}>
                                    <li>Visit the Quickychat official platform.</li>
                                    <li>Create a new account or log in with your existing credentials.</li>
                                    <li>Once logged in, you will have access to your dashboard.</li>
                                </ol>
                            </Card.Body>
                        </Card>

                        {/* Step 2 */}
                        <Card style={{ backgroundColor: '#2d2d2d', borderColor: '#444', marginBottom: '24px' }}>
                            <Card.Header style={{ backgroundColor: '#333', borderBottom: '1px solid #444', padding: '20px' }}>
                                <div className="d-flex align-items-center">
                                    <div
                                        style={{
                                            backgroundColor: '#28a745',
                                            borderRadius: '50%',
                                            width: '40px',
                                            height: '40px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginRight: '16px'
                                        }}
                                    >
                                        <span style={{ color: '#fff', fontWeight: 'bold' }}>2</span>
                                    </div>
                                    <div>
                                        <h5 style={{ color: '#fff', margin: 0 }}>Create & Publish an Agent</h5>
                                        <small style={{ color: '#ccc' }}>Generate your unique access key</small>
                                    </div>
                                </div>
                            </Card.Header>
                            <Card.Body style={{ padding: '24px' }}>
                                <ol style={{ color: '#ccc', lineHeight: '1.6' }}>
                                    <li>Create a new AI agent from your dashboard.</li>
                                    <li>Configure its behavior, data sources, and responses.</li>
                                    <li>Publish the agent to obtain your unique <strong style={{ color: '#fff' }}>accessKey</strong>.</li>
                                </ol>
                                <div
                                    style={{
                                        backgroundColor: '#1a3a52',
                                        padding: '12px 16px',
                                        borderRadius: '8px',
                                        marginTop: '16px',
                                        borderLeft: '4px solid #17a2b8'
                                    }}
                                >
                                    <small style={{ color: '#b8daff' }}>
                                        🔑 Your <strong>accessKey</strong> is required for all API requests.
                                    </small>
                                </div>
                            </Card.Body>
                        </Card>

                        {/* Step 3 */}
                        <Card style={{ backgroundColor: '#2d2d2d', borderColor: '#444', marginBottom: '24px' }}>
                            <Card.Header style={{ backgroundColor: '#333', borderBottom: '1px solid #444', padding: '20px' }}>
                                <div className="d-flex align-items-center">
                                    <div
                                        style={{
                                            backgroundColor: '#ffc107',
                                            borderRadius: '50%',
                                            width: '40px',
                                            height: '40px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginRight: '16px'
                                        }}
                                    >
                                        <span style={{ color: '#000', fontWeight: 'bold' }}>3</span>
                                    </div>
                                    <div>
                                        <h5 style={{ color: '#fff', margin: 0 }}>Connect via API</h5>
                                        <small style={{ color: '#ccc' }}>Send messages to your agent programmatically</small>
                                    </div>
                                </div>
                            </Card.Header>
                            <Card.Body style={{ padding: '24px' }}>
                                <p style={{ color: '#ccc' }}>
                                    Use the following endpoint to interact with your AI agent:
                                </p>
                                <div
                                    style={{
                                        backgroundColor: '#1a1a1a',
                                        padding: '12px',
                                        borderRadius: '8px',
                                        border: '1px solid #555',
                                        marginBottom: '16px'
                                    }}
                                >
                                    <code style={{ color: '#17a2b8' }}>
                                        POST https://api.quickychat.com/chatagents/&lt;accessKey&gt;/chat
                                    </code>
                                </div>

                                <p style={{ color: '#ccc' }}>Request Body:</p>
                                <pre
                                    style={{
                                        backgroundColor: '#1a1a1a',
                                        padding: '12px',
                                        borderRadius: '8px',
                                        color: '#ffc107',
                                        border: '1px solid #555',
                                        overflowX: 'auto'
                                    }}
                                >
{`{
  "sessionId": "string", 
  "message": {
    "role": "string",
    "content": "string"
  }
}`}
                                </pre>
                            </Card.Body>
                        </Card>

                        {/* Step 4 */}
                        <Card style={{ backgroundColor: '#2d2d2d', borderColor: '#444', marginBottom: '24px' }}>
                            <Card.Header style={{ backgroundColor: '#333', borderBottom: '1px solid #444', padding: '20px' }}>
                                <div className="d-flex align-items-center">
                                    <div
                                        style={{
                                            backgroundColor: '#6f42c1',
                                            borderRadius: '50%',
                                            width: '40px',
                                            height: '40px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginRight: '16px'
                                        }}
                                    >
                                        <FaCode size={18} style={{ color: '#fff' }} />
                                    </div>
                                    <div>
                                        <h5 style={{ color: '#fff', margin: 0 }}>Example Usage</h5>
                                        <small style={{ color: '#ccc' }}>Sample API call in TypeScript</small>
                                    </div>
                                </div>
                            </Card.Header>
                            <Card.Body style={{ padding: '24px' }}>
                                <pre
                                    style={{
                                        backgroundColor: '#1a1a1a',
                                        padding: '12px',
                                        borderRadius: '8px',
                                        color: '#17a2b8',
                                        border: '1px solid #555',
                                        overflowX: 'auto'
                                    }}
                                >
{`const response = await fetch(
  \`https://api.quickychat.com/chatagents/<accessKey>/chat\`,
  {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      sessionId: sessionId,
      message: {
        role: "user",
        content: "What is the status of my order?"
      }
    }),
  }
);

const data = await response.json();`}
                                </pre>
                            </Card.Body>
                        </Card>

                        {/* Step 4 */}
<Card style={{ backgroundColor: '#2d2d2d', borderColor: '#444', marginBottom: '24px' }}>
  <Card.Header style={{ backgroundColor: '#333', borderBottom: '1px solid #444', padding: '20px' }}>
    <div className="d-flex align-items-center">
      <div
        style={{
          backgroundColor: '#17a2b8',
          borderRadius: '50%',
          width: '40px',
          height: '40px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginRight: '16px'
        }}
      >
        <FaCheckCircle size={18} style={{ color: '#fff' }} />
      </div>
      <div>
        <h5 style={{ color: '#fff', margin: 0 }}>API Response</h5>
        <small style={{ color: '#ccc' }}>Structure returned from the Quickychat API</small>
      </div>
    </div>
  </Card.Header>
  <Card.Body style={{ padding: '24px' }}>
    <p style={{ color: '#ccc' }}>
      When you send a message to your agent, the API returns the agent’s response along with the session information:
    </p>

    <pre
      style={{
        backgroundColor: '#1a1a1a',
        padding: '12px',
        borderRadius: '8px',
        color: '#28a745',
        border: '1px solid #555',
        overflowX: 'auto'
      }}
    >
{`{
  "message": {
    "role": "string", 
    "content": "string"
  },
  "sessionId": "string",
  "metadata": {}
}`}
    </pre>

    <ul style={{ color: '#ccc', lineHeight: '1.6', marginTop: '16px' }}>
      <li>
        <strong style={{ color: '#fff' }}>message.role</strong> – Indicates who sent the message (e.g., <code>system</code>, <code>assistant</code>).
      </li>
      <li>
        <strong style={{ color: '#fff' }}>message.content</strong> – The actual text response generated by your AI agent.
      </li>
      <li>
        <strong style={{ color: '#fff' }}>sessionId</strong> – Unique conversation ID. Save this and reuse it to maintain conversation context.
      </li>
      <li>
        <strong style={{ color: '#fff' }}>metadata</strong> – Additional information related to the request (reserved for advanced use cases).
      </li>
    </ul>

    <div
      style={{
        backgroundColor: '#1a3a52',
        padding: '12px 16px',
        borderRadius: '8px',
        marginTop: '16px',
        borderLeft: '4px solid #17a2b8'
      }}
    >
      <small style={{ color: '#b8daff' }}>
        💡 Always store the returned <strong>sessionId</strong> and send it back in the next request to keep the conversation continuous.
      </small>
    </div>
  </Card.Body>
</Card>


                        {/* Troubleshooting */}
                        <Card style={{ backgroundColor: '#2d2d2d', borderColor: '#444', marginBottom: '24px' }}>
                            <Card.Header style={{ backgroundColor: '#333', borderBottom: '1px solid #444', padding: '20px' }}>
                                <div className="d-flex align-items-center">
                                    <FaTools size={24} style={{ color: '#ffc107', marginRight: '12px' }} />
                                    <h5 style={{ color: '#fff', margin: 0 }}>Troubleshooting Tips</h5>
                                </div>
                            </Card.Header>
                            <Card.Body style={{ padding: '24px' }}>
                                <ul style={{ color: '#ccc', lineHeight: '1.6', margin: 0 }}>
                                    <li>Ensure your <strong style={{ color: '#fff' }}>accessKey</strong> is correct.</li>
                                    <li>Verify the API endpoint URL and HTTP method.</li>
                                    <li>Make sure the request body follows the required JSON format.</li>
                                    <li>Store and reuse the returned <strong style={{ color: '#fff' }}>sessionId</strong> for continuous conversations.</li>
                                </ul>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                {/* Call to Action */}
                <Row className="text-center text-white py-5">
                    <ScrollAnimationWrapper>
                        <Col md={12}>
                            <h2 className="py-2">Start Building with the Quickychat API Today!</h2>
                            <Link to="/dashboard">
                                <Button variant="primary" size="lg">
                                    Get Your Access Key
                                </Button>
                            </Link>
                        </Col>
                    </ScrollAnimationWrapper>
                </Row>
            </Container>
        </div>
    );
};

export default APIDocumentation;
